import {
  Component,
  input,
  signal,
  WritableSignal,
  effect
} from '@angular/core';
import {
  PerivisErrorContainerDto,
  hasErrors
} from '../../models/validation-errors.model'; // make sure hasErrors function is exported

@Component({
  selector: 'app-perivis-validation',
  standalone: false,
  templateUrl: './perivis-validation.component.html'
})
export class PerivisValidationComponent {
  
  // Avoids template errors
  objectKeys = Object.keys;

  /**
   * Signal input to receive the error object.
   */
  readonly errors = input<PerivisErrorContainerDto | null>(null);

  /**
   * Signal to control the visibility of the PrimeNG dialog.
   */
  readonly displayDialog: WritableSignal<boolean> = signal(false);

  constructor() {
    effect(() => {
      const currentErrors = this.errors();
      this.displayDialog.set(hasErrors(currentErrors));
    });
  }

  /**
   * Closes the error dialog.
   * The parent component must clear the errors.
   */
  closeDialog(): void {
    this.displayDialog.set(false);
  }

  public copyId(id: string): void {
    if (id) {
      navigator.clipboard.writeText(id);
    }
  }
}